import { render } from "./InvestmentSummary.vue?vue&type=template&id=142c89ce&scoped=true"
import script from "./InvestmentSummary.vue?vue&type=script&lang=js"
export * from "./InvestmentSummary.vue?vue&type=script&lang=js"

import "./InvestmentSummary.vue?vue&type=style&index=0&id=142c89ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-142c89ce"

export default script